import { getFilters } from '../../webcommon/header/filterheader/selectors';

export const getFilterDefinitions = state => (
    state.impactAnalysis.summary.filterDefinitions
);

export const getInitialised = state => state.impactAnalysis.summary.initialised;

export const getDefaultFilters = state => (
    state.impactAnalysis.summary.defaultFilters
);

export const getSummaryStatsInfo = state => (
    state.impactAnalysis.summary.summaryInfoStats
);

export const getSummaryInfoLoaded = state => (
    state.impactAnalysis.summary.summaryInfoLoaded
);

export const getShowDefaultMappings = state => (
    state.impactAnalysis.summary.showDefaultMappings
);

export const getShowCsaSummary = state => (
    state.impactAnalysis.summary.showCsaSummary
);

export const getCurrencyToShow = state => (
    state.impactAnalysis.summary.currencyToShow
);

export const getCsas = (state) => {
    const filterState = getFilters(state, 'ImpactAnalysis');
    if (filterState) {
        const filter = filterState.find(obj => obj.definition.id === 'csa');
        if (filter) {
            return filter.value;
        }
    }
    return [];
};

export const getDateFrom = (state) => {
    const filterState = getFilters(state, 'ImpactAnalysis');
    if (filterState) {
        const filter = filterState.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getDateIsToday = (state) => {
    const filterState = getFilters(state, 'ImpactAnalysis');
    if (filterState) {
        const filter = filterState.find(obj => obj.definition.id === 'runDate');
        return filter && filter.value && filter.value.today;
    }
    return false;
};

export const getCurrentServerFilters = state => (
    state.impactAnalysis.summary.currentServerFilters
);

export const getSummaryGridRows = state => (
    state.impactAnalysis.summary.summaryGridRows
);

export const getSummaryGridColumns = state => (
    state.impactAnalysis.summary.summaryGridColumns
);

export const getLoading = state => (
    state.impactAnalysis.summary.loading
);

export const getCurrentCsaStatus = state => (
    state.impactAnalysis.summary.currentStatus
);

export const getCurrentCsaType = state => (
    state.impactAnalysis.summary.currentType
);

export const getTransactionId = state => (
    state.impactAnalysis.summary.transactionId
);
